'use strict';

var React = require('react');
var array = require('../../helpers/array.js');

const SET_LOADING = 'SET_LOADING';
const SET_DATA = 'SET_DATA';
const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
const SET_FOCUS_ROW = 'SET_FOCUS_ROW';
const CLEAR_FOCUS_ROW = 'CLEAR_FOCUS_ROW';
const SET_SELECT_ROW = 'SET_SELECT_ROW';
const SET_EXPANDED_ROW = 'SET_EXPANDED_ROW';
const SET_ALL_SELECT_ROW = 'SET_ALL_SELECT_ROW';
const CLEAR_SELECT_ROW = 'CLEAR_SELECT_ROW';
const PATCH_START = 'PATCH_START';
const PATCH_END = 'PATCH_END';
const SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER';
const ADD_TO_CURRENT_SORT = 'ADD_TO_CURRENT_SORT';
const REMOVE_FROM_CURRENT_SORT = 'REMOVE_FROM_CURRENT_SORT';
const RESET_SORT = 'RESET_SORT';
const tableEngineReducer = (state, action) => {
    switch (action.type) {
        case SET_LOADING:
            return { ...state, isLoading: action.data };
        case SET_DATA:
            return { ...state, data: [...action.data], isLoading: false };
        case SET_CURRENT_PAGE:
            return { ...state, currentPage: action.data };
        case SET_FOCUS_ROW:
            return { ...state, focusRow: action.data[state.keyField] };
        case CLEAR_FOCUS_ROW:
            return { ...state, focusRow: null };
        case SET_SELECT_ROW:
            return { ...state, selectedRows: array.addOrRemove(state.selectedRows, action.data) };
        case SET_EXPANDED_ROW:
            return { ...state, expandedRows: array.addOrRemove(state.expandedRows, action.data) };
        case SET_ALL_SELECT_ROW:
            return { ...state, selectedRows: [...action.data] };
        case CLEAR_SELECT_ROW:
            return { ...state, selectedRows: [] };
        case PATCH_START:
            return {
                ...state,
                data: state.data.map(d => (d[state.keyField] === action.data[state.keyField] ? action.data : d)),
                editingRows: array.addOrRemove(state.editingRows, action.data[state.keyField]),
            };
        case PATCH_END:
            return {
                ...state,
                editingRows: array.addOrRemove(state.editingRows, action.data[state.keyField]),
            };
        case SET_ACTIVE_FILTER:
            return { ...state, activeFilter: action.data, isLoading: true };
        case ADD_TO_CURRENT_SORT:
            return {
                ...state,
                currentSort: [...state.currentSort, action.data],
                isLoading: true,
            };
        case REMOVE_FROM_CURRENT_SORT: {
            const nextSort = array.removeObjectKeyFromArray(state.currentSort, action.data, d => d.filter);
            return {
                ...state,
                currentSort: nextSort,
                isLoading: state.currentSort.length !== nextSort.length,
            };
        }
        case RESET_SORT:
            return {
                ...state,
                currentSort: [],
            };
        default:
            throw new Error(`NotImplemented action - type: ${action.type}`);
    }
};
function setData(dispatch, data) {
    dispatch({
        type: SET_DATA,
        data,
    });
    clearFocusRow(dispatch);
    clearSelectRow(dispatch);
}
function setCurrentPage(dispatch, data) {
    dispatch({
        type: SET_CURRENT_PAGE,
        data,
    });
}
function clearSelectRow(dispatch) {
    dispatch({ type: CLEAR_SELECT_ROW });
}
function expandedUnexpanded(dispatch, data) {
    dispatch({
        type: SET_EXPANDED_ROW,
        data,
    });
}
function setSelectRow(dispatch, data) {
    dispatch({
        type: SET_SELECT_ROW,
        data,
    });
}
function setAllSelectRow(dispatch, data) {
    dispatch({
        type: SET_ALL_SELECT_ROW,
        data,
    });
}
function clearFocusRow(dispatch) {
    dispatch({ type: CLEAR_FOCUS_ROW });
}
function setFocusRow(dispatch, data) {
    dispatch({
        type: SET_FOCUS_ROW,
        data,
    });
}
function patchStart(dispatch, data) {
    dispatch({
        type: PATCH_START,
        data,
    });
}
function patchEnd(dispatch, data) {
    dispatch({
        type: PATCH_END,
        data,
    });
}
function setLoading(dispatch, data) {
    dispatch({
        type: SET_LOADING,
        data,
    });
}
function setActiveFilter(dispatch, data, isInitial = false) {
    dispatch({
        type: SET_ACTIVE_FILTER,
        data,
    });
    if (!isInitial) {
        setCurrentPage(dispatch, 0);
    }
    return data;
}
function addToCurrentSort(dispatch, data, isInitial = false) {
    dispatch({
        type: ADD_TO_CURRENT_SORT,
        data,
    });
    if (!isInitial) {
        setCurrentPage(dispatch, 0);
    }
}
function removeFromCurrentSort(dispatch, data, isInitial = false) {
    dispatch({
        type: REMOVE_FROM_CURRENT_SORT,
        data,
    });
    if (!isInitial) {
        setCurrentPage(dispatch, 0);
    }
}
function isFilterActive(filter, currentSort) {
    let isActive = false;
    for (const sort of currentSort) {
        if (sort.filter === filter) {
            isActive = true;
            break;
        }
    }
    return isActive;
}
function getInitialSortForFilter(filter, currentSort) {
    let initialSort;
    for (const sort of currentSort) {
        if (sort.filter === filter) {
            initialSort = sort;
            break;
        }
    }
    return initialSort;
}
function resetSort(dispatch) {
    dispatch({ type: RESET_SORT });
}
function useTable(keyField, initialData, isLoading = true, initialPage = 0, initialSort = []) {
    const initialState = {
        keyField,
        data: initialData || [],
        currentPage: initialPage,
        focusRow: null,
        selectedRows: [],
        expandedRows: [],
        isLoading,
        editingRows: [],
        activeFilter: null,
        currentSort: initialSort || [],
    };
    const [state, dispatch] = React.useReducer(tableEngineReducer, initialState);
    return {
        keyField,
        state,
        getInitialSortForFilter: (filter) => getInitialSortForFilter(filter, initialSort),
        setLoading: (value) => setLoading(dispatch, value),
        setData: (data) => setData(dispatch, data),
        getData: () => state.data,
        setCurrentPage: (data) => setCurrentPage(dispatch, data),
        expandedUnexpanded: (data) => expandedUnexpanded(dispatch, data),
        selectUnselect: (data) => setSelectRow(dispatch, data),
        setAllSelectRow: (data) => setAllSelectRow(dispatch, data),
        unSelectAll: () => clearSelectRow(dispatch),
        setFocusRow: (data) => setFocusRow(dispatch, data),
        unFocus: () => clearFocusRow(dispatch),
        getFocusRow: () => state.data.find(d => state.focusRow === d[keyField]),
        getSelectedRows: () => state.data.filter(d => state.selectedRows.includes(d[keyField])),
        patchStart: (data) => patchStart(dispatch, data),
        patchEnd: (data) => patchEnd(dispatch, data),
        setActiveFilter: (data, isInitial) => setActiveFilter(dispatch, data, isInitial),
        getCurrentSort: () => state.currentSort,
        addToCurrentSort: (data, isInitial) => addToCurrentSort(dispatch, data, isInitial),
        removeFromCurrentSort: (data, isInitial) => removeFromCurrentSort(dispatch, data, isInitial),
        isFilterActive: (filter) => isFilterActive(filter, state.currentSort),
        resetSort: () => resetSort(dispatch),
    };
}

exports.useTable = useTable;
//# sourceMappingURL=useTable.js.map
